import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
} from 'firebase/firestore';
import { db } from '../../firebase';
import { getCategoryById } from '../../data/boardCategories';

function BoardSearch() {
  const [keyword, setKeyword] = useState('');
  const [threads, setThreads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getDocs(query(collection(db, 'threads'), orderBy('createdAt', 'desc'), limit(120)))
      .then((snap) => {
        setThreads(
          snap.docs
            .map((item) => ({ id: item.id, ...item.data() }))
            .filter((t) => !t.isHidden)
        );
      })
      .catch((err) => console.error('[BoardSearch]', err))
      .finally(() => setLoading(false));
  }, []);

  const filteredThreads = useMemo(() => {
    const normalized = keyword.trim().toLowerCase();
    if (!normalized) return threads;
    return threads.filter((t) =>
      `${t.title} ${t.content}`.toLowerCase().includes(normalized)
    );
  }, [keyword, threads]);

  return (
    <div style={{ maxWidth: '896px', margin: '0 auto', padding: '32px 16px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
      <section className="revisit-panel" style={{ borderRadius: '16px', padding: '20px' }}>
        <h1 style={{ fontSize: '20px', fontWeight: 700, color: 'var(--ui-accent-text)', margin: 0 }}>
          スレッド検索
        </h1>
        <p className="revisit-meta" style={{ fontSize: '14px', marginTop: '8px' }}>
          タイトルや本文から気になる相談・体験談を探せます。
        </p>
        <input
          type="search"
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
          placeholder="キーワードを入力"
          style={{
            marginTop: '16px',
            width: '100%',
            borderRadius: '8px',
            border: '1px solid var(--ch-form-border)',
            padding: '10px 12px',
            fontSize: '14px',
            backgroundColor: 'var(--ch-input-bg)',
            color: 'var(--ch-text)',
            boxSizing: 'border-box',
          }}
        />
      </section>

      <section style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {loading ? (
          <div className="revisit-panel" style={{ borderRadius: '16px', padding: '20px' }}>
            <p className="revisit-meta" style={{ fontSize: '14px' }}>読み込み中...</p>
          </div>
        ) : filteredThreads.length === 0 ? (
          <div className="revisit-panel" style={{ borderRadius: '16px', padding: '20px' }}>
            <p className="revisit-meta" style={{ fontSize: '14px' }}>
              条件に合うスレッドはありませんでした。
            </p>
          </div>
        ) : (
          filteredThreads.map((thread) => {
            const category = getCategoryById(thread.categoryId);
            return (
              <Link
                key={thread.id}
                to={`/board/${thread.categoryId}/${thread.subCategoryId}/${thread.id}`}
                className="surface-link revisit-card"
                style={{ display: 'block', borderRadius: '12px', padding: '14px 16px' }}
              >
                <p style={{ fontSize: '14px', fontWeight: 600, color: 'var(--ui-accent-text)', margin: 0 }}>
                  {thread.title}
                </p>
                <p className="revisit-meta" style={{ fontSize: '12px', marginTop: '4px' }}>
                  {category?.name ?? thread.categoryId} ・ 返信 {thread.replyCount}
                </p>
              </Link>
            );
          })
        )}
      </section>
    </div>
  );
}

export default BoardSearch;
